import { FC } from "react";
import PageTemplate from "../PageTemplate";
import ContactsPage from "./ContatcsPage";

const Catalog: FC = () => {
    return <PageTemplate Page={ContactsPage} />;
};

export default Catalog;
